import type { DocumentaryResourceVM } from "@shared-kernel/domain/types/documentary-resource";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const documentaryResourcesRetrieve = createApiThunk<DocumentaryResourceVM[], void>(
  "documentaryResource/retrieve",
  async (_: void, { extra: { sharedRepository } }) => {
    return sharedRepository!.getVisibleDocumentaryResources();
  },
);
